function removeTrailingSlash(url: string): string {
  return url.endsWith("/") ? url.slice(0, -1) : url;
}

/**
 * Base URL for API calls from the Admin app.
 *
 * - Defaults to same-origin (recommended for production deployments).
 * - Can be overridden in development via Vite env var `VITE_API_URL`.
 */
export function getApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_URL;
  if (typeof configured === "string" && configured.trim() !== "") {
    return removeTrailingSlash(configured.trim());
  }
  return window.location.origin;
}

export function getAdminImagesUploadUrl(): string {
  return `${getApiBaseUrl()}/api/admin/images/upload`;
}








